const passwordRegx = /^([0-9]{4,8})$/
function IsPasswordValid (value) {
    return passwordRegx.test(value);
}
export {IsPasswordValid};